import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TextField, Typography, Button } from "@mui/material";
import Spinner from "react-bootstrap/Spinner";
import { useAppSelector } from "../../store/reduxHooks";
import { reducerTypes } from "../../store/Users/types";
import VideoApi from "../../api/video";
import { PageContainer } from "../../components/Page.styled";
import PaginationBlock from "../../components/forPages/PaginationBlock";
import { customAlert } from "../../components/Alert/AlertFunction";
import VideoCard from "./components/VideoCard";
import VideoCreate from "./components/VideoCreate";

function AllVideo() {
  const dispatch = useDispatch();
  const { user } = useAppSelector((store) => store.user);
  const [search, setSearch] = useState("");
  const [searchForInput, setSearchForInput] = useState("");
  const [video, setVideo] = useState([]);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(1);
  const [loadind, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  async function getFilteredVideo({ page, search }) {
    setLoading(true);

    const result = await VideoApi.getFiltered({
      page: page + 1,
      pageSize: 10,
      search,
    });
    setLoading(false);
    if (result) {
      if (result?.video) {
        setVideo(result?.video);
        dispatch({
          type: reducerTypes.GET_VIDEO,
          payload: result?.video,
        });
      }

      if (result?.count) {
        setCount(result?.count);
      }
    } else {
      customAlert({ message: "Помилка отримання відео" });
      setVideo([]);
      setCount(1);
    }
  }

  async function createVideo({ video }) {
    video = { ...video, text: video?.text?.split("/n/"), images: video?.images?.split("/n/") };
    const result = await VideoApi.create(video);
    if (result && !result?.message) {
      customAlert({ message: "Success", severity: "success" });
      setIsOpen(false);
      getFilteredVideo({ page, search });
    } else {
      customAlert({ message: result?.message || "Помилка створення відео" });
    }
  }

  useEffect(() => {
    getFilteredVideo({ page, search });
  }, [page, search]);

  return (
    <PageContainer>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Typography variant="h2">ВІДЕО</Typography>
      </div>
      <div style={{ marginBottom: "1rem", display: "flex", justifyContent: "space-between", position: "relative", zIndex: 1, gap: "1rem", paddingBottom: "2rem", borderBottom: "1px solid gray" }}>
        <div style={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
          <TextField
            size="small"
            label="Пошук"
            variant="outlined"
            id="Search"
            value={searchForInput}
            onChange={(e) => setSearchForInput(e.target.value?.toLowerCase())}
            onBlur={(e) => {
              setPage(0);
              setSearch(e.target.value?.toLowerCase()?.trim());
            }}
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                setPage(0);
                setSearch(e.target.value?.toLowerCase()?.trim());
              }
            }}
          />
        </div>
        {user?.role === "ADMIN" && (
          <div>
            <Button onClick={() => setIsOpen((prev) => !prev)} variant="outlined">
              Створити відео
            </Button>
          </div>
        )}
      </div>

      {isOpen && <VideoCreate setIsOpen={setIsOpen} createVideo={createVideo} user={user} />}

      {!loadind ? (
        <div className="videoContentHeight videoContainer">
          {/* {news?.map((el) => (
            <NewsCard key={el?.id} news={el} />
          ))} */}
          {video?.map((el) => (
            <VideoCard key={el?.id} video={el} />
          ))}
        </div>
      ) : (
        <div className="videoContentHeight" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Spinner animation="border" role="status" style={{ height: "200px", width: "200px" }}></Spinner>
        </div>
      )}

      <PaginationBlock count={count} page={page} setPage={setPage} />
    </PageContainer>
  );
}

export default AllVideo;
